import { DialogProvider } from "./ConfirmDialog";

const ContextProvider = ({ children }) => {
	return <DialogProvider>{children}</DialogProvider>;
};

export default ContextProvider;
